import './dropdown_component.scss'
import { Controller } from 'stimulus'
// import { createPopper } from '@popperjs/core'

export default class extends Controller {
}
